<template>
  <div class="page-box">
    <w-navbar nav_title="AI看相"  @mobileLeftBtn="$router.back()"/>
    <div class="share-box" v-if="!url">
      <img src="https://files.wondercv.com/m/ai/share-bg.png" alt="" class="share-bg" crossorigin="anonymous">
      <img src="https://files.wondercv.com/m/ai/homeTitle.png" alt=""  class="result-title" crossorigin="anonymous">
      <div class="card-box">
        <div class="title short">
          大数据预测
        </div>
        <img src="https://files.wondercv.com/m/ai/dot.png" alt="" v-for="item in 4" :key="item" :class="['dot','dot'+item]" crossorigin="anonymous">
        <div class="predict-box">
          <p class="predict-title"><span>"</span>{{$route.params.level1}}{{$route.params.level2 ? '-' + $route.params.level2 : ''}}{{$route.params.level3 ? '-' + $route.params.level3 : ''}}<span>"</span></p>
          <p class="subtitle">{{$route.params.top_achievement}}</p>
          <div class="portrait-box">
            <img :src="$route.params.img" alt="" class="user-image" @load="handleLoading">
            <div class="tag" :class="['tag' + (index + 1)]" v-for="(item, index) in $route.params.face_description.split('，').slice(0,3)" :key="index">{{item}}</div>
          </div>
        </div>
      </div>
      <div class="flex-between qcode-box flex-center">
        <div>
          <p class="text1">扫码关注，回复【测试】</p>
          <p class="text2">测一测天命职业</p>
        </div>
        <img src="https://files.wondercv.com//m/ai/share-code.png" width="56" height="56" crossorigin="anonymous"/>
      </div>
    </div>
    <div class="page-content" v-else>
      <img :src="url" width="316" height="533" style="object-fit: contain;background: #000" />
      <div class="flex-center">
        <img width="21" height="21" src="https://files.wondercv.com//m/ai/save.png"/>
        <p>长按即可保存图片</p>
      </div>
    </div>
  </div>
</template>

<script>
  import Card from "./components/Card"
  import Predict from "./components/Predict"
  import {getPng} from "../../assets/js/htmlToPdf";
  import WNavbar from "../../components/global/w-navbar"
  export default {
    name: "ShareCard",
    components:{Card, Predict, WNavbar},
    data(){
      return {
        url: "",
      }
    },
    created() {

    },
    mounted() {
      setTimeout(()=>{
        this.$route.meta.shareByWx('和上千万求职者形象匹配', { title: '不知道自己适合做什么？试试大数据看相！', imgUrl: 'https://files.wondercv.com/m/ai/logo.png' },process.env.VUE_APP_HOST + '/ai/faces')
      },1000)
      let {params} = this.$route
      if (Object.keys(params).length > 0) {

      } else {
        this.$router.replace("/ai/faces")
      }

    },
    methods:{
      handleLoading(){
        setTimeout(()=>{
          let dom = document.querySelector(".share-box")
          getPng(dom).then(res=>{
            this.url = res
          }).catch(err=>{
            console.log(err)
          })
        },0)
      }
    }
  }
</script>

<style scoped lang="scss">
.page-box{
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    position: relative;
    padding-top: 44px;
    .page-content{
      width: 100%;
      height: 100%;
      display: flex;
      background: rgba(0, 0, 0, 1);
      justify-content: center;
      align-items: center;
      flex-direction: column;
      div{
        margin-top: 24px;
        p{
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #CBB5FF;
          line-height: 20px;
        }
      }
    }
  }
.share-box{
  box-sizing: border-box;
  position: relative;
  background: #7E53E8;
  min-height: 605px;
  height: 633px;
  top: -700px;
  .result-title{
    margin-left: 24px;
    margin-top: 15px;
    margin-bottom: 24px;
    position: relative;
    z-index: 2;
    width: calc( 100vw * (296 / 375));
  }
  .share-bg{
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .card-box{
    width: 347px;
    background: #250A66;
    box-shadow: 0px 0px 12px 0px #582EBC;
    border-radius: 10px;
    border: 1px solid #4E26B1;
    position: relative;
    z-index: 2;
    margin: 0 auto;
    padding: 28px 0px 30px;
    .title{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -12px;
      height: 41px;
      text-align: center;
      line-height: 41px;
      color:#fff;
      font-size: 16px;
      font-weight: 500;
    }
    .long{
      width: 210px;
      background-image: url("https://files.wondercv.com/m/ai/title-long.png");
      background-size: 100%;
    }
    .short{
      width: 190px;
      background-image: url("https://files.wondercv.com/m/ai/titile-short.png");
      background-size: 100%;
    }
    .dot{
      width: 20px;
      height: 20px;
      position: absolute;
    }
    .dot1{
      top: 10px;
      left: 10px;
    }
    .dot2{
      top: 10px;
      right: 10px;
      transform: rotate(90deg);
    }
    .dot3{
      left:10px;
      bottom: 10px;
      transform: rotate(270deg);
    }
    .dot4{
      right: 10px;
      bottom: 10px;
      transform: rotate(180deg);
    }
    .predict-box{
      padding: 24px 24px 0px 28px;
      position: relative;
      .predict-title{
        width: 100%;
        text-align: center;
        font-size: 28px;
        font-weight: 800;
        margin-bottom: 8px;
        color: #FFFFFF;
        span{
          font-size: 32px;
        }
      }
      .subtitle{
        font-size: 20px;
        font-weight: 600;
        color: #FFFFFF;
        text-align: center;
        line-height: 28px;
      }
      .portrait-box{
        width: 230px;
        height: 230px;
        margin: 0px auto 2px;
        background-image: url("https://files.wondercv.com/m/ai/portrait.png");
        background-size: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .user-image{
          width: 120px;
          height: 120px;
          border-radius: 50%;
          margin: 29px auto;
        }
        .tag{
          position: absolute;
          background: #6739D8;
          border-radius: 4px;
          padding: 2px 8px;
          line-height: 20px;
          text-align: center;
          font-weight: 400;
          color: #FFFFFF;
        }
        .tag1{
          left: -17px;
          top: 23px;
        }
        .tag2{
          left: -36px;
          bottom: 27px;
        }
        .tag3{
          right: -36px;
          bottom: 59px;
        }

      }
      .ps{
        text-align: center;
        bottom: -4px;
        color: #7E53E8;
        font-size: 13px;
        font-weight: 400;
        position: absolute;
        left: 0;
        right: 0;
      }
    }
  }
  .qcode-box{
    position: relative;
    z-index: 2;
    padding: 15px 14px;
  }
  .text1{
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 22px;
    letter-spacing: 1px;
    margin-bottom: 4px;
  }
  .text2{
    font-size: 11px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 16px;
    letter-spacing: 1px;
  }
}
</style>
